
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BranchList',
  props: {
    count: {
      type: Number,
      default: 1
    },
    loading: {
      type: Boolean,
      default: false
    },
    isExpanded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    countText(): string {
      const count = this.count - 1

      if (count === 1) {
        return `${count} more run on this branch`
      } else if (count > 1 && count <= 30) {
        return `${count} more runs on this branch`
      } else if (count > 30) {
        return '30+ runs on this branch'
      } else {
        return ''
      }
    }
  },
  methods: {
    toggleItems(): void {
      this.$emit('toggled', !this.isExpanded)
    }
  }
})
